import { getMockAdmissionList } from "../admission/AdmittedPatientsModal";

export const mapAdmissionRowToPatient = (row) => ({
  uhid: row.uhid || "",
  patientName: row.patientName || "",
  contact: row.contact || "",
  patientGender: row.gender || "",
  patientAge: row.age || "",
  doctorName: row.doctorName || "",
  wardName: row.wardName || "",
  bedNo: row.bedNo || "",
  admissionId: row.admissionId || 0,
  ipdNo: row.ipdNo || `IP/${row.admissionId || 0}/${new Date().getFullYear()}`,
  admDateTime: row.admDateTime || "",
});

export const getAdmittedPatientSearchOptions = () =>
  getMockAdmissionList()
    .filter((row) => row.status === "Admitted")
    .map((row) => ({
      id: row.admissionId,
      label: `${row.patientName} | ${row.uhid} | ${row.contact} | ${row.age}Y | ${row.gender}`,
      value: row.patientName,
      row,
    }));

export const MOCK_STAFF_OPTIONS = [
  { id: 1, value: 1, label: "Sister Mary Joseph" },
  { id: 2, value: 2, label: "Sister Anita Desai" },
  { id: 3, value: 3, label: "Dr. RMO Sharma" },
  { id: 4, value: 4, label: "Dr. RMO Patil" },
];

export const MOCK_DOCTOR_OPTIONS = [
  { id: 1, value: 1, label: "Dr. Sanjeev Kulkarni" },
  { id: 2, value: 2, label: "Dr Mahesh Mandora" },
  { id: 3, value: 3, label: "Dr Anita Rao" },
  { id: 4, value: 4, label: "Dr. Tukaram Aute" },
  { id: 5, value: 5, label: "Dr. Koustub Sodani" },
];

export const MOCK_NOTE_TEMPLATE_OPTIONS = [
  { id: "tpl-1", value: "tpl-1", label: "General Nursing Note" },
  { id: "tpl-2", value: "tpl-2", label: "Post-Operative Care" },
  { id: "tpl-3", value: "tpl-3", label: "Vitals Monitoring" },
  { id: "tpl-4", value: "tpl-4", label: "Medication Administration" },
];

export const getDefaultDateTime = () => {
  const now = new Date();
  return {
    date: now.toISOString().split("T")[0],
    time: `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`,
  };
};
